import React, { forwardRef } from 'react';

import MUILinearProgress, {
  LinearProgressProps as MUILinearProgressProps,
} from '@material-ui/core/LinearProgress';

interface LinearProgressProps extends MUILinearProgressProps {}

const LinearProgress = forwardRef<unknown, LinearProgressProps>(
  (props, ref) => {
    return <MUILinearProgress {...props} ref={ref} />;
  }
);
LinearProgress.displayName = 'Progress';

export default LinearProgress;
